import {useMemo} from 'react';

import {RuleBundleModel} from '../../../../../../models/api/ruleBundleModel';
import {CustomFields} from '../../../../../editors/commons/customFieldsModel';
import {RuleIntegration} from '../../../../ruleIntegrationModel';
import {EditorStateActions, useEditorState} from '../../../hooks/useEditorState';
import {createInitialCsatState} from '../state/csatEditorDefaults';
import {CsatEditorState, CsatTagsModels} from '../state/csatEditorState';
import {CsatEditorSpecificActions, useCsatEditorSpecificState} from './useCsatEditorSpecificState';

export interface CsatEditorStateActions extends CsatEditorSpecificActions {
  onUpdateRuleName: EditorStateActions['onUpdateRuleName'];
  onToggleIsActive: EditorStateActions['onToggleIsActive'];

  onValidation: EditorStateActions['onValidation'];

  onAddCondition: EditorStateActions['onAddCondition'];
  onUpdateCondition: EditorStateActions['onUpdateCondition'];
  onDeleteCondition: EditorStateActions['onDeleteCondition'];
}

interface UseCsatEditorStateReturnType extends CsatEditorStateActions {
  csatEditorState: CsatEditorState;
}

export function useCsatEditorState(
  ruleBundle: RuleBundleModel | undefined,
  customFields: CustomFields,
  ruleIntegration: RuleIntegration,
  csatTags: CsatTagsModels,
  namespace?: string,
): UseCsatEditorStateReturnType {
  const initialState = useMemo(() => createInitialCsatState(ruleBundle, csatTags), [csatTags, ruleBundle]);

  // General CSAT Rule.
  const {
    ruleEditorState,
    onUpdateRuleName,
    onValidation,
    onToggleIsActive,
    onAddCondition,
    onUpdateCondition,
    onDeleteCondition,
  } = useEditorState(initialState.rule, customFields, ruleIntegration, undefined, namespace);

  // CSAT specific state.
  const {csatEditorState, ...csatSpecificActions} = useCsatEditorSpecificState(
    initialState.csatSpecificState,
  );

  return {
    csatEditorState: {
      ...ruleEditorState,
      csatState: csatEditorState,
    },

    onUpdateRuleName,
    onValidation,
    onToggleIsActive,
    onAddCondition,
    onUpdateCondition,
    onDeleteCondition,

    ...csatSpecificActions,
  };
}
